import clsx from "clsx";
import { FunctionComponent } from "react";

import BrandedContentSponsor from "@ui/components/ledes/BrandedContentSponsor";
import { Campaign } from "@voxmedia/duet-context/context/campaign-context";

import * as styles from "./StickyNav.css";
import { StickyNavContentProps } from "./types";

interface Props extends StickyNavContentProps {
  headline?: string;
  isBranded?: boolean;
  campaign?: Campaign;
}

const StickyNavStandardContent: FunctionComponent<Props> = ({
  Logo,
  headline,
  isBranded = false,
  hamburgerButton,
  campaign,
  commentCount,
  notificationsButton,
}) => {
  return (
    <div className={clsx(styles.standardInnerContainer)}>
      <a
        href="/"
        aria-label="Click to visit the homepage"
        tabIndex={-1}
        className={styles.logoContainer}
      >
        <Logo className={clsx(styles.logo, isBranded && styles.logoBranded)} />
      </a>
      {headline && <div className={styles.headline}>{headline}</div>}
      <div className={styles.rightMenu}>
        {campaign && (
          <BrandedContentSponsor
            campaign={campaign}
            imageClassName={clsx(
              isBranded
                ? styles.campaignImageContainerBrandedNav
                : styles.campaignImageContainer,
            )}
            textClassName={clsx(
              styles.campaignTextContainer,
              isBranded && styles.campaignTextContainerBrandedNav,
            )}
          />
        )}
        {commentCount}
        {notificationsButton}
        {hamburgerButton}
      </div>
    </div>
  );
};

export default StickyNavStandardContent;
